import React from 'react'
import { Link } from 'react-router-dom'
import { getHeadshot } from './../../../../shared/utilities/getHeadshot.function'
import { getFullName } from './../../formatters'
import { getHeroHeadline, getHeroIntro, getBookingLink } from './../../content'
import ComplianceDisclaimer from './../../../../components/shared/ComplianceDisclaimer/ComplianceDisclaimer.component'

import './HeroSection.component.scss'

const HeroSection = ({ subsiteData }) => {
  const showImage = subsiteData?.s_agent_picture && subsiteData?.u_picture
  const fullName = getFullName(subsiteData)
  const booking = getBookingLink(subsiteData)

  return (
    <section id='SubsiteHero' className='subsite-section is-blue'>
      <div className='subsite-shell hero-grid'>
        {showImage ? (
          <div className='hero-image'>
            <img
              src={getHeadshot(subsiteData)}
              alt={fullName ? `${fullName}, licensed insurance advisor` : 'Licensed insurance advisor'}
            />
          </div>
        ) : (
          <></>
        )}
        <div className='hero-copy'>
          <h1>{getHeroHeadline(subsiteData)}</h1>
          <p className='hero-subhead'>{getHeroIntro(subsiteData)}</p>
          <div className='hero-ctas'>
            {booking.external ? (
              <a className='subsite-btn' href={booking.href} target='_blank' rel='noopener noreferrer'>
                Book Your Appointment Now
              </a>
            ) : (
              <Link className='subsite-btn' to={booking.href}>
                Book Your Appointment Now
              </Link>
            )}
          </div>
          <ComplianceDisclaimer variant='short' tone='light' />
        </div>
      </div>
    </section>
  )
}

export default HeroSection
